import { render, staticRenderFns } from "./NavChatUnread.vue?vue&type=template&id=684c6eee&"
import script from "./NavChatUnread.vue?vue&type=script&lang=ts&"
export * from "./NavChatUnread.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports